/*
export const AppRoutes = {
  UserDash: { path: "/dashboard" },
  Dashboard: { path: "/dashboard" },
  Products: { path: "/products" },
  Licences: { path: "/dashboard/licences" },
  Login: { path: "/login" },
  Bind: { path: "/bind" },
  Register: { path: "/register" },
  Purchase: { path: "/purchase" }
};
*/

import "./App.css";
import UserDashboard from "./pages/UserDashboard";
import LoginForm from "./components/LoginForm";
import { Navigate } from "react-router-dom";

const AppRoutes = (isLoggedIn) => [
  {
    path: "/login",
    element: <LoginForm/>
  }
]

export default AppRoutes;